import axios, { AxiosError } from "axios"
import { DOCUMENT_TYPE_PATH, LIST_PATH } from "../../constants/paths"
import { requestInterceptorSuccessCredentials, requestInterceptorErrorSecurityCredentials, responseInterceptorSuccessCredentials, responseInterceptorErrorCredentials } from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getDocumentTypesService = async () => {
  try {
    const result = await instance.get(DOCUMENT_TYPE_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
